export enum COLOR_TEXT {
  GRADIENT = "linear-gradient(to right, #1E88E5, #00BCD4)",
}
